import controller from './saved-cards.controller';

export default {
  controller,
  template: require('./saved-cards.html')
};



// WEBPACK FOOTER //
// src/app/buy/saved-cards/saved-cards.component.ts